import type firebase from "firebase/compat/app";

const promise: Promise<typeof firebase> = import("./lib").then((mod) => mod.default);

const getFirebase = (): Promise<typeof firebase> => promise;

export default getFirebase;
